// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"b2eQp":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CloudUpload);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillCloudUploadGeneric1160Svg = require("illustration:./S2_fill_cloudUpload_generic1_160.svg");
var _s2FillCloudUploadGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillCloudUploadGeneric1160Svg);
var _s2FillCloudUploadGeneric196Svg = require("illustration:./S2_fill_cloudUpload_generic1_96.svg");
var _s2FillCloudUploadGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillCloudUploadGeneric196Svg);
var _s2FillCloudUploadGeneric148Svg = require("illustration:./S2_fill_cloudUpload_generic1_48.svg");
var _s2FillCloudUploadGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillCloudUploadGeneric148Svg);
var _icon = require("../../../src/Icon");
var _reactAriaComponents = require("react-aria-components");
'use client';
function CloudUpload(props) {
    [props] = (0, _reactAriaComponents.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillCloudUploadGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillCloudUploadGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillCloudUploadGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_cloudUpload_generic1_160.svg":"cWAQO","illustration:./S2_fill_cloudUpload_generic1_96.svg":"1SY7q","illustration:./S2_fill_cloudUpload_generic1_48.svg":"fNqzu","../../../src/Icon":"jQAJE","react-aria-components":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cWAQO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "44b6af__d",
                        x1: -13.164,
                        x2: 184.35,
                        y1: 129.007,
                        y2: 1.534,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "44b6af__e",
                        x1: 150.707,
                        x2: 68.621,
                        y1: 45.009,
                        y2: 138.642,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "44b6af__f",
                        x1: 44.245,
                        x2: 195.026,
                        y1: 146.062,
                        y2: 56.46,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "44b6af__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 51.5105 -54.6429 0 54.643 51.51)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "44b6af__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 51.5105 -54.6429 0 54.643 51.51)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "44b6af__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 125.6,
                            height: 118.4,
                            x: 18.398,
                            y: 23.2,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "44b6af__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M117.542 54.65q-.009.162-.01.32c13.37.79 23.98 11.85 23.98 26.52s-11.38 26.56-25.43 26.56h-32.57V74.07l17.5 14.04c.74.59 1.62.88 2.5.88 1.17 0 2.33-.52 3.12-1.5 1.38-1.72 1.1-4.24-.62-5.62l-23.67-19c-1.47-1.18-3.57-1.17-5.03.02l-23.33 19c-1.72 1.4-1.98 3.92-.58 5.63 1.4 1.72 3.92 1.98 5.63.58l16.47-13.42v33.37h8V136c0 2.21-1.79 4-4 4s-4-1.79-4-4v-27.95h-39.03v-.02c-9.95-.17-17.98-8.64-17.98-19.08 0-8.79 5.7-16.18 13.45-18.4-.35-1.61-.56-3.28-.56-5.01 0-12.26 9.51-22.19 21.24-22.19 2.87 0 5.6.6 8.1 1.68 3.77-12.24 14.75-21.1 27.72-21.1 16.08 0 29.11 13.61 29.11 30.4q-.001.158-.01.32"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#44b6af__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#44b6af__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 125.6,
                            height: 118.4,
                            x: 18.398,
                            y: 23.2,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M18.398 23.2h125.6v118.4h-125.6z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 54.643,
                            cy: 51.511,
                            fill: "url(#44b6af__c)",
                            rx: 54.643,
                            ry: 51.511,
                            transform: "matrix(1 -.00132 .00148 1 34.695 -23.645)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#44b6af__d)",
                            d: "M66.34 2.285c-9.647-5.626-21.868-5.661-31.55-.089l-96.836 55.736c-9.483 5.458-9.5 18.343-.028 23.822l96.195 55.657c9.668 5.592 21.89 5.585 31.548-.02l95.998-55.709c9.421-5.467 9.438-18.28.029-23.768z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#44b6af__e)",
                            d: "M36.5 79.414c2.147-44.202 41.9-78.395 88.79-76.371 46.89 2.023 83.162 39.497 81.015 83.7-2.147 44.201-41.899 78.394-88.789 76.37s-83.162-39.497-81.015-83.7"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#44b6af__f)",
                            d: "M-32.49 108.559c18.64-7.495 38.741-7.174 56.157-.618 34.85 13.152 55.127 5.021 69.191-27.755 7.006-16.448 20.683-30.377 39.343-37.88 37.308-14.981 80.378 1.274 96.246 36.339 15.869 35.065-1.5 75.602-38.799 90.601-18.701 7.521-38.842 7.169-56.284.554-34.793-13.082-55.032-4.92-69.079 27.896-7.023 16.408-20.697 30.289-39.336 37.785-37.278 14.991-80.348-1.263-96.208-36.309s1.492-75.621 38.77-90.613"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 54.643,
                            cy: 51.511,
                            fill: "url(#44b6af__g)",
                            rx: 54.643,
                            ry: 51.511,
                            transform: "matrix(1 -.00132 .00148 1 81.957 -6.848)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1SY7q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "937f15__d",
                        x1: -7.898,
                        x2: 110.611,
                        y1: 77.404,
                        y2: 0.92,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "937f15__e",
                        x1: 90.423,
                        x2: 41.171,
                        y1: 27.006,
                        y2: 83.185,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "937f15__f",
                        x1: 26.546,
                        x2: 117.015,
                        y1: 87.636,
                        y2: 33.875,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "937f15__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 30.9063 -32.7857 0 32.786 30.906)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "937f15__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 30.9063 -32.7857 0 32.786 30.906)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "937f15__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 75.36,
                            height: 71.04,
                            x: 11.039,
                            y: 13.92,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "937f15__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "M70.524 32.79q-.005.098-.006.192c8.022.474 14.388 7.11 14.388 15.912S78.078 64.83 69.648 64.83H50.106V44.442l10.5 8.424c.444.354.972.528 1.5.528.702 0 1.398-.312 1.872-.9.828-1.032.66-2.544-.372-3.372l-14.202-11.4c-.882-.708-2.142-.702-3.018.012l-13.998 11.4c-1.032.84-1.188 2.352-.348 3.378.84 1.032 2.352 1.188 3.378.348l9.882-8.052V64.83h4.8V81.6c0 1.326-1.074 2.4-2.4 2.4s-2.4-1.074-2.4-2.4V64.83H21.882v-.012c-5.97-.102-10.788-5.184-10.788-11.448 0-5.274 3.42-9.708 8.07-11.04-.21-.966-.336-1.968-.336-3.006 0-7.356 5.706-13.314 12.744-13.314 1.722 0 3.36.36 4.86 1.008 2.262-7.344 8.85-12.66 16.632-12.66 9.648 0 17.466 8.166 17.466 18.24q0 .095-.006.192"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#937f15__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#937f15__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 75.36,
                            height: 71.04,
                            x: 11.039,
                            y: 13.92,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M11.04 13.92H86.4v71.04H11.04z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 32.786,
                            cy: 30.906,
                            fill: "url(#937f15__c)",
                            rx: 32.786,
                            ry: 30.906,
                            transform: "matrix(1 -.00132 .00148 1 20.816 -14.188)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#937f15__d)",
                            d: "M39.804 1.37c-5.787-3.375-13.12-3.396-18.93-.053l-58.1 33.442c-5.69 3.275-5.7 11.006-.018 14.293l57.718 33.394c5.8 3.355 13.133 3.351 18.928-.012l57.599-33.425c5.652-3.28 5.663-10.968.017-14.261z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#937f15__e)",
                            d: "M21.899 47.648C23.187 21.127 47.039.611 75.172 1.826s49.897 23.698 48.609 50.22c-1.288 26.52-25.139 47.036-53.273 45.822S20.61 74.17 21.898 47.648"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#937f15__f)",
                            d: "M-19.495 65.135C-8.31 60.637 3.75 60.83 14.2 64.764c20.91 7.891 33.077 3.012 41.515-16.653 4.203-9.869 12.41-18.226 23.606-22.729 22.384-8.988 48.226.765 57.748 21.804s-.901 45.361-23.28 54.361c-11.221 4.513-23.305 4.301-33.77.332-20.876-7.849-33.02-2.952-41.447 16.738-4.215 9.844-12.42 18.173-23.602 22.671-22.367 8.995-48.21-.758-57.725-21.785s.895-45.373 23.261-54.368"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 32.786,
                            cy: 30.906,
                            fill: "url(#937f15__g)",
                            rx: 32.786,
                            ry: 30.906,
                            transform: "matrix(1 -.00132 .00148 1 49.176 -4.108)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fNqzu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "fd2638__d",
                        x1: -3.949,
                        x2: 55.306,
                        y1: 38.702,
                        y2: 0.46,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "fd2638__e",
                        x1: 45.213,
                        x2: 20.587,
                        y1: 13.503,
                        y2: 41.593,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "fd2638__f",
                        x1: 13.273,
                        x2: 58.507,
                        y1: 43.818,
                        y2: 16.938,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "fd2638__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 15.4531 -16.3929 0 16.393 15.453)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "fd2638__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(0 15.4531 -16.3929 0 16.393 15.453)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "fd2638__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 37.68,
                            height: 35.52,
                            x: 5.52,
                            y: 6.96,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "fd2638__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    fillRule: "evenodd",
                    d: "m35.262 16.395-.003.096c4.01.237 7.194 3.555 7.194 7.956s-3.414 7.968-7.63 7.968h-9.771V22.22l5.25 4.212c.223.177.487.264.75.264.352 0 .7-.156.937-.45.414-.516.33-1.272-.186-1.686l-7.101-5.7c-.441-.354-1.071-.351-1.51.006l-6.998 5.7c-.516.42-.594 1.176-.174 1.689.42.516 1.176.594 1.689.174l4.94-4.026v10.01h2.4V40.8c0 .663-.536 1.2-1.2 1.2-.662 0-1.2-.537-1.2-1.2v-8.385H10.942v-.006c-2.985-.051-5.394-2.592-5.394-5.724 0-2.637 1.71-4.854 4.035-5.52-.105-.483-.168-.984-.168-1.503 0-3.678 2.853-6.657 6.372-6.657.86 0 1.68.18 2.43.504 1.13-3.672 4.425-6.33 8.316-6.33 4.824 0 8.733 4.083 8.733 9.12z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#fd2638__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#fd2638__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 37.68,
                            height: 35.52,
                            x: 5.52,
                            y: 6.96,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M5.52 6.96H43.2v35.52H5.52z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 16.393,
                            cy: 15.453,
                            fill: "url(#fd2638__c)",
                            rx: 16.393,
                            ry: 15.453,
                            transform: "matrix(1 -.00132 .00148 1 10.41 -7.094)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#fd2638__d)",
                            d: "M19.902.685c-2.894-1.688-6.56-1.698-9.465-.026l-29.05 16.72c-2.845 1.638-2.85 5.503-.009 7.147l28.859 16.697c2.9 1.678 6.567 1.676 9.464-.006l28.8-16.712c2.826-1.64 2.83-5.485.008-7.131z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#fd2638__e)",
                            d: "M10.951 23.824C11.595 10.564 23.521.306 37.588.913s24.949 11.849 24.305 25.11-12.57 23.518-26.637 22.91c-14.067-.606-24.949-11.848-24.305-25.109"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#fd2638__f)",
                            d: "M-9.747 32.567c5.591-2.248 11.622-2.152 16.847-.185 10.455 3.946 16.538 1.506 20.757-8.327 2.102-4.934 6.205-9.113 11.803-11.364 11.192-4.494 24.113.382 28.874 10.902s-.45 22.68-11.64 27.18c-5.61 2.257-11.652 2.151-16.885.167-10.438-3.925-16.51-1.476-20.724 8.368-2.107 4.923-6.21 9.087-11.8 11.336C-3.7 75.14-16.62 70.264-21.379 59.75s.447-22.686 11.63-27.184"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                            cx: 16.393,
                            cy: 15.453,
                            fill: "url(#fd2638__g)",
                            rx: 16.393,
                            ry: 15.453,
                            transform: "matrix(1 -.00132 .00148 1 24.586 -2.055)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=DropZone.7999b63e.js.map
